import type { ImageStripItem } from "@prototypes/image-strip/ImageStrip";
import type { ImageAttachment } from "../../common/types/Attachment";
import { cdnImage } from "../../common/utils/image.util";

export type BookingStripImage = ImageAttachment & ImageStripItem;

export function arrangedBookingImages(booking: {
    imageURL?: string | null;
    croppedImageURL?: string | null;
    images?: ImageAttachment[] | null;
}): ImageAttachment[] {
    const images = booking.images ?? [];
    const primaryMissingFromImages = Boolean(
        booking.imageURL && !images.some((image) => image.url === booking.imageURL),
    );

    return [
        ...(primaryMissingFromImages && booking.imageURL
            ? [
                  {
                      id: booking.imageURL,
                      url: booking.imageURL,
                      croppedImageURL: booking.croppedImageURL ?? null,
                      mimeType: "image/jpeg",
                  } satisfies ImageAttachment,
              ]
            : []),
        ...images,
    ];
}

export function toBookingStripImages(images: ImageAttachment[]): BookingStripImage[] {
    return images.map((image) => ({
        ...image,
        id: image.id ?? image.url,
        src: cdnImage(image.url, { height: 500, width: 0 }),
        href: image.url,
    }));
}

export function bookingAttachmentsFromStrip(
    images: BookingStripImage[],
): ImageAttachment[] {
    return images.map(({ src: _src, alt: _alt, href: _href, ...attachment }) => {
        return attachment;
    });
}
